import { Flex, FlexGap } from '@pancakeswap/uikit'
import { ReactNode } from 'react'
import styled from 'styled-components'

const Title = styled.div<{ align?: string }>`
  font-size: 40px;
  font-weight: 700;
  text-align: ${({ align }) => align};
  font-family: 'IBM Plex Sans';
  line-height: 56px;
  color: ${({ theme }) => theme.colors.white};
`

const SubTitle = styled.div<{ align?: string }>`
  font-size: 14px;
  text-align: ${({ align }) => align};
  color: ${({ theme }) => theme.colors.textSubtle};
  line-height: 21px;
`

interface EPageHeaderProps {
  pageName: string
  subTitle?: string
  children?: ReactNode
  align?: 'left' | 'center' | 'right'
}

const EPageHeader = ({ pageName, children, subTitle = '', align = 'center', ...props }: EPageHeaderProps) => {
  return (
    <Flex
      flexDirection="column"
      position="relative"
      alignItems={align === 'center' ? 'center' : align === 'left' ? 'flex-start' : 'flex-end'}
      my="20px"
      width="100%"
      {...props}
    >
      <Flex
        flexDirection="column"
        alignItems={align === 'center' ? 'center' : align === 'left' ? 'flex-start' : 'flex-end'}
        mb="8px"
        width="100%"
      >
        <Title align={align}>{pageName}</Title>
        <SubTitle align={align}>{subTitle}</SubTitle>
      </Flex>
      {children}
    </Flex>
  )
}

export default EPageHeader